// Blocked people (M58, docs/report-block-contact.md D208). The server leaves
// a blocked direct chat out of the list; this hides it at once, before the
// list is fetched again.

interface ChatLike {
  type: 'direct' | 'group';
  participants: Array<{ id: string }>;
}

/** The other person in a direct chat, or null for a group. */
export function directPartnerId(
  chat: ChatLike,
  currentUserId: string | undefined
): string | null {
  if (chat.type !== 'direct') return null;
  return chat.participants.find((p) => p.id !== currentUserId)?.id ?? null;
}

/** A direct chat with someone I blocked. Groups never are. */
export function isBlockedChat(
  chat: ChatLike,
  blockedIds: ReadonlySet<string>,
  currentUserId: string | undefined
): boolean {
  const partner = directPartnerId(chat, currentUserId);
  return partner !== null && blockedIds.has(partner);
}

export function visibleConversations<T extends ChatLike>(
  chats: T[],
  blockedIds: ReadonlySet<string>,
  currentUserId: string | undefined
): T[] {
  if (blockedIds.size === 0) return chats;
  return chats.filter(
    (chat) => !isBlockedChat(chat, blockedIds, currentUserId)
  );
}
